module.exports = __webpack_public_path__ + "img/envelop-white.8e7f40fa.svg";